<nz-modal
    nzTitle='Lịch sử valid'
    [nzWidth]="700"
    [(nzVisible)]="visibleValidHistory"
    (nzOnCancel)="closeModalLog()"
    [nzFooter]="modalFooterConfig"
    [nzContent]="modalContentConfig"
  >
    <ng-template #modalContentConfig>
      <div class="search-bar">
        <div class="search-box">
          <dx-date-box #nextTab [(ngModel)]="formFilter.fromDate" placeholder="dd/MM/yyyy" type="date" [showClearButton]="true"
                       [useMaskBehavior]="true" displayFormat="dd/MM/yyyy"></dx-date-box>
        </div>
        <div class="search-box">
          <dx-date-box #nextTab [(ngModel)]="formFilter.toDate" placeholder="dd/MM/yyyy" type="date" [showClearButton]="true"
                      [useMaskBehavior]="true" displayFormat="dd/MM/yyyy"></dx-date-box>
        </div>
        <div class="search-box">
          <button style="height: 30px;" nz-button nzType="primary" nzSize="default" (click)="doSearch()">
            <span class="fa fa-fw fa-search"></span>
            Tìm kiếm
          </button>
        </div>
      </div>
      <dx-data-grid
        #grid
        [dataSource]="datas"
        [showColumnLines]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [allowColumnResizing]="true"
        columnResizingMode="widget"
        [columnMinWidth]="50"
        [columnAutoWidth]="true"
        [height]="500"
      >
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column caption="Username" [width]="200" dataField="userName"></dxi-column>
        <dxi-column caption="Action" [width]="150" cellTemplate="cellValid"></dxi-column>
        <dxi-column caption="Ngày valid" dataField="dateValid" dataType="date" format="HH:mm dd/MM/yy"></dxi-column>
        <div *dxTemplate="let item of 'cellValid'">
          {{item.data.validType == true ? 'Valid' : 'Hủy valid'}}
        </div>
      </dx-data-grid>
    </ng-template>
    <ng-template #modalFooterConfig>
      <button nz-button nzType="default" (click)="closeModalLog()">
        Hủy
      </button>
    </ng-template>
</nz-modal>